import React from "react";
import { useDetallePaletizacion } from "../hooks/useDetallePaletizacion";
import LoadMask from "Utils/LoadMask/LoadMask";
import { ListadoPallets } from "./ListadoPallets/ListadoPallets";
import { TotalesRecepcion } from "./TotalesRecepcion";

export const PaletizacionForm = ({ idPaletizacion, regresar, modoLectura }) => {
    const {
        pallets,
        setPallets,
        ConfirmarEstadoRecepcion,

        cargando,
    } = useDetallePaletizacion(idPaletizacion, regresar);

    const palletsAprobados = pallets.filter((pallet) => pallet.recibido_bodega);

    return (
        <LoadMask loading={cargando} blur>
            <TotalesRecepcion pallets={pallets} />

            <ListadoPallets
                pallets={pallets}
                setPallets={setPallets}
                modoLectura={modoLectura}
            />

            <div className="d-flex justify-content-center mt-5 gap-2rem">
                <button className="btn btn-outline-dark" onClick={regresar}>
                    Regresar
                </button>
                {!modoLectura &&
                    (palletsAprobados.length > 0 ? (
                        <button
                            className={
                                palletsAprobados.length === pallets.length
                                    ? "btn btn-primary"
                                    : "btn btn-warning"
                            }
                            onClick={ConfirmarEstadoRecepcion}
                        >
                            {palletsAprobados.length === pallets.length
                                ? "Aceptar todos"
                                : `Aceptar seleccionados (${palletsAprobados.length})`}
                        </button>
                    ) : (
                        <button
                            className="btn btn-danger"
                            onClick={ConfirmarEstadoRecepcion}
                        >
                            Rechazar todo
                        </button>
                    ))}
            </div>
        </LoadMask>
    );
};
